import validate from 'validate.js';
import { formCreateLyceeSchema } from '../error/schemas/formCreateLycee';

import { getErrors } from '../error/getErrors';
import { isValid } from '../error/isValid';

export const lyceeFormErrorHandling = (lyceeState, field, value) => {
  let errors = lyceeState.errors;

  const message = validate({ [field]: value }, formCreateLyceeSchema);
  errors = getErrors(
    errors,
    field,
    message && message[field] && message[field][0]
  );

  return {
    ...lyceeState,
    values: {
      ...lyceeState.values,
      [field]: value
    },
    errors,
    isValid: isValid(errors)
  };
};
